import { Controller } from "@hotwired/stimulus"

// Drives the six single-character boxes of the email sign-in code (see
// students/passcodes/verify_form). Keeps a hidden `code` field in sync with the
// boxes, auto-advances focus, handles backspace and a pasted full code, and
// submits the form once all six digits are present — so a visitor who pastes or
// types the last digit never needs to reach for the Verify button.
export default class extends Controller {
  static targets = ["box", "field"]

  connect() {
    this.syncField()
  }

  onInput(event) {
    const box = event.target
    // Keep only the last typed digit; drop anything non-numeric.
    box.value = box.value.replace(/\D/g, "").slice(-1)

    if (box.value) this.focusNext(box)
    this.syncField()
    this.submitIfComplete()
  }

  onKeydown(event) {
    if (event.key !== "Backspace") return
    // Backspace on an empty box steps back and clears the previous one, so a
    // held backspace walks the whole code out.
    if (event.target.value === "") {
      const prev = this.previousBox(event.target)
      if (prev) {
        prev.value = ""
        prev.focus()
        this.syncField()
        event.preventDefault()
      }
    }
  }

  onPaste(event) {
    event.preventDefault()
    const digits = (event.clipboardData?.getData("text") || "").replace(/\D/g, "").slice(0, this.boxTargets.length)
    if (!digits) return

    this.boxTargets.forEach((box, i) => { box.value = digits[i] || "" })
    const next = this.boxTargets[Math.min(digits.length, this.boxTargets.length - 1)]
    next?.focus()
    this.syncField()
    this.submitIfComplete()
  }

  focusNext(box) {
    const index = this.boxTargets.indexOf(box)
    this.boxTargets[index + 1]?.focus()
  }

  previousBox(box) {
    return this.boxTargets[this.boxTargets.indexOf(box) - 1]
  }

  syncField() {
    this.fieldTarget.value = this.boxTargets.map((b) => b.value).join("")
  }

  submitIfComplete() {
    if (this.fieldTarget.value.length !== this.boxTargets.length) return

    if (typeof this.element.requestSubmit === "function") {
      this.element.requestSubmit()
    } else {
      this.element.submit()
    }
  }
}
